import { ProductContent } from "@/lib/redux/features/esim/types";

export type ResolvedProductHomeContent = {
  item: ProductContent;
  data: Record<string, unknown>;
};

const hasData = (value: unknown): value is Record<string, unknown> =>
  Boolean(value && typeof value === "object" && Object.keys(value).length > 0);

/**
 * Resolve content hiển thị cho từng `ProductContent` (`position` đứng độc lập, vd `PRODUCT_HOME`) — khác
 * `resolveEsimContent` (chọn 1 bản ghi tốt nhất cho 1 esim): ở đây có thể có NHIỀU bản ghi cùng hiển thị
 * (dạng tab), nên resolve ngôn ngữ RIÊNG cho từng item, loại bỏ item nào không có data ở cả 2 ngôn ngữ.
 *
 * Rule ngôn ngữ: ưu tiên `content[lang hiện tại]` nếu có data, không thì fallback `content.vi` — `vi` luôn
 * là đích fallback cuối (không vòng ngược sang `en`), rỗng cả 2 thì loại bỏ item đó luôn.
 */
export const resolveProductHomeContents = (
  contents: ProductContent[],
  lang: string,
): ResolvedProductHomeContent[] => {
  const key = lang.toLowerCase().startsWith("en") ? "en" : "vi";

  return contents
    .filter((item) => item.status === "ACTIVE")
    .map((item) => {
      const preferred = item.content?.[key];
      const data = hasData(preferred) ? preferred : item.content?.vi;
      return hasData(data) ? { item, data } : null;
    })
    .filter((entry): entry is ResolvedProductHomeContent => entry !== null)
    .sort((a, b) => (a.item.priority ?? Number.POSITIVE_INFINITY) - (b.item.priority ?? Number.POSITIVE_INFINITY));
};
